import React, { useState, useEffect } from "react";
import BarChart from '../chart/BarChart'
import DataTable from "react-data-table-component";
import MaterialIssueRequstModal from "../modal/MaterialIssueRequstModal";
import MaterialIssueProductWise from "../modal/MaterialIssueProductWise";
import MaterialInspectionReportModal from "../modal/MaterialInspectionReportMadal";
import MaterialRejectDetailsModal from "../modal/MaterialRejectDetailsModal";
import MaterialWastageLogModal from "../modal/MaterialWastageLogModal";
import MaterialRequestModal from '../modal/MaterialRequestModal';
import MaterialAcceptanceDetailsModal from '../modal/MaterialAcceptanceDetailsModal';
import SuperMaterialWastageReporModal from '../modal/SuperMaterialWastageReporModal';
import MaterialRejectionReportModal from '../modal/MaterialRejectionReportModal';
import MaterialRejectionNewLogModal from '../modal/MaterialRejectionNewLogModal';
import { formatDate } from "../../utils/formatDate";
import { MdErrorOutline } from "react-icons/md";
import { RiCheckboxMultipleLine } from "react-icons/ri";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import Loader from "../loader/Loader";
import SupplierModal from "./SupplierModal";
import { WrapText } from "lucide-react";
import { toast } from "react-toastify";
const customStyles = {
  headCells: {
    style: {
      fontWeight: 'bold',
      fontSize: '14px',
      backgroundColor: '#f8f9fa',
    },
  },
};
export default function RowMaterials() {
  const [materialIssue, setMaterialIssue] = useState(false)
  const [materialIssueProductWise, setMaterialIssueProductWise] = useState(false)
  const [materialInspection, setMaterialInspection] = useState(false)
  const [materialReject, setMaterialReject] = useState(false)
  const [materialWastage, setMaterialWastage] = useState(false)
  const [materialRequest, setMaterialRequest] = useState(false)
  const [materialAcceptanceDetails, setMaterialAcceptanceDetails] = useState(false)
  const [superMaterialWastageReport, setSuperMaterialWastageReport] = useState(false)
  const [materialRejectionReport, setMaterialRejectionReport] = useState(false)
  const [newMaterial, setNewMaterial] = useState(false)
  const [materialList, setMaterialList] = useState([]);
  const [acceptedList, setAcceptedList] = useState([]);
  const [wastageList, setWastageList] = useState([])
  const [newLogList, setNewLogList] = useState([])
  const [stockStatus, setStockStatus] = useState([])
  const [materialAlertsList, setMaterialAlertsList] = useState([])
  const [selectedMaterialId, setSelectedMaterialId] = useState(null);
  const [wastageReportId, setWastageReportId] = useState(null)
  const [rejectionReportId, setRejectionReportId] = useState(null)
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [supplierModal, setSupplierModal] = useState(false)
  const [acceptedmaterial, setAcceptedmaterial] = useState([])
  const [barChartData, setBarChartData] = useState([])
  const today = new Date().toISOString().slice(0, 10);
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(today);
  const [rejectionStartDate, setRejectionStartDate] = useState(today);
  const [rejectionEndDate, setRejectionEndDate] = useState(today);
  const handleAcceptClick = (id) => {
    setSelectedMaterialId(id);
    setMaterialInspection(true);
  };
  const handleDetailsClick = (id) => {
    setSelectedMaterialId(id);
    setMaterialAcceptanceDetails(true);
  };
  const handleDeleteClick = async (id) => {
    const token = getAuthToken();
    if (!token) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this material issue request?"
    );

    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${config.API}/supervisor/materialdeleterequest/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data?.success) {
        toast.success("Material issue request deleted successfully.");
        fetchMaterialList();
        fetchAcceptedList();
      } else {
        alert(response.data?.message || "Failed to delete.");
      }
    } catch (err) {
      console.error(err);

      alert(
        err.response?.data?.message ||
        "Something went wrong while deleting."
      );
    }
  };
  useEffect(() => {
    fetchMaterialList();
    fetchAcceptedList();
    fetchWastageList();
    fetchNewList();
    fetchStockStatusList()
    fetchMaterialAlertsList();
    fetchAcceptedmaterial()
    fetchBarChartReport()
  }, []);
  const fetchMaterialList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/materialissuerequests`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMaterialList(response?.data?.materialissuerequests || []);
      } else {
        setMaterialList([]);
      }
    } catch (err) {
      console.error("Error fetching materialissuerequests:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchAcceptedList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/incomingmaterialacceptance`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setAcceptedList(response?.data?.incoming_materials || []);
      } else {
        setAcceptedList([]);
      }
    } catch (err) {
      console.error("Error fetching material/accepted:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchAcceptedmaterial = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/acceptedmaterial`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setAcceptedmaterial(response?.data?.material || []);

      } else {
        setAcceptedmaterial([]);
      }
    } catch (err) {
      console.error("Error fetching material/accepted:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchWastageList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API}/supervisor/materialwasteget`,
        {
          start_date: startDate,
          end_date: endDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setWastageList(response.data || []);
      } else {
        setWastageList([]);
      }
    } catch (err) {
      console.error("Error fetching WastageList:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchNewList = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      setLoading(true);

      const response = await axios.post(
        `${config.API}/supervisor/materialrejectionget`,
        {
          start_date: rejectionStartDate,
          end_date: rejectionEndDate,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const result = response?.data || {};
      setNewLogList(result);

    } catch (err) {
      console.error("Error fetching newList:", err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchStockStatusList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/floorstock`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setStockStatus(response?.data?.floorstock || []);
      } else {
        setStockStatus([]);
      }
    } catch (err) {
      console.error("Error fetching fetchStockStatusList:", err.message);
    } finally {
      setLoading(false)
    }
  };

  const fetchMaterialAlertsList = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true)
      const response = await axios.get(`${config.API}/supervisor/materialalerts`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      if (response?.data && response?.data?.success) {
        setMaterialAlertsList(response?.data?.materialalerts || []);
      } else {
        setMaterialAlertsList([]);
      }

    } catch (err) {
      console.error("Error fetching fetchMaterialAlertsList:", err.message);
    } finally {
      setLoading(false)
    }
  };
  const fetchBarChartReport = async () => {
    const token = getAuthToken();
    if (!token) return;
    try {
      setLoading(true);
      const response = await axios.get(`${config.API}/senmanager/materialConsumption`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      const result = response?.data;
      if (result?.success) {
        setBarChartData(result);
        console.log(result, "result222")
      } else {
        console.warn("API call failed:", result?.message || "Something went wrong");
      }
    } catch (err) {
      console.error("Error fetching fetchBarChartReport:", err.message);
    } finally {
      setLoading(false);
    }
  };
  const BarChartData = {
    labels: barChartData?.data?.map((item) => item?.material_master?.material_name),
    datasets: [
      {
        label: "Planned",
        data: barChartData?.data?.map((item) => item?.total_consumed),
        backgroundColor: "#0a28a3",
      },
    ],
  };
  const getBadge = (text, type) => {
    const colorMap = {
      urgent: "danger",
      normal: "success",
      pending: "warning",
      approved: "primary",
      accepted: "success",

    };
    const key = (type || text)?.toLowerCase();
    const colorClass = colorMap[key]
      ? `bg-${colorMap[key]}-subtle text-${colorMap[key]}`
      : "bg-secondary-subtle text-secondary";

    return <span className={`badge ${colorClass} p-2`}>{text}</span>;
  };
  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      cell: (row) => (
        <span
          style={{ cursor: "pointer" }}
        >
          {row?.material_master?.material_code}
        </span>
      ),
    },
    { name: "Material", selector: (row) => row?.material_master?.material_name, sortable: true },
    { name: "Quantity", selector: (row) => row.quantity },
    {
      name: "Urgency",
      cell: (row) => getBadge(row.urgency, row.urgencyType),
    },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    {
      name: "Time",
      selector: (row) => {
        if (!row.created_at) return "";
        const date = new Date(row.created_at);
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      name: "Status",
      cell: (row) => getBadge(row.status),
    },
    {
      name: "Actions",
      cell: (row) =>
        row.status?.toLowerCase() === "pending" ? (
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{ whiteSpace: "nowrap" }}
            onClick={() => {
              setSelectedId(row.id);
              setSupplierModal(true);
            }}
          >
            Approve
          </button>
        ) : (
          <button
            className="btn btn-outline-secondary btn-sm"
            style={{ whiteSpace: "nowrap" }}
            onClick={() => {
              setSelectedId(row.id);
              setMaterialRequest(true)
            }}
          >
            View Details
          </button>
        ),
    }
  ];
  const getBadges = (text, type) => {
    const colorMap = {
      critical: "danger",
      low: "warning",
      hold: "warning",
      approved: "primary",
      rejected: "danger",
    };
    const key = (type || text)?.toLowerCase();
    const colorClass = colorMap[key]
      ? `bg-${colorMap[key]}-subtle text-${colorMap[key]}`
      : "bg-secondary-subtle text-secondary";

    return <span className={`badge ${colorClass} p-2`}>{text}</span>;
  };
  const Acceptedcolumns = [
    { name: "ID", selector: (row) => row.material_master?.material_code, sortable: true },
    { name: "Material", selector: (row) => row?.material_master?.material_name, sortable: true, wrap: true },
    { name: "Q", selector: (row) => row?.expected_qty },
    { name: "Supplier", selector: (row) => row?.supplier_name },
    { name: "Batch ID", selector: (row) => row?.batch_number },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    {
      name: "Time",
      selector: (row) => {
        if (!row.created_at) return "";
        const date = new Date(row.created_at);
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      name: "Status",
      cell: (row) => getBadges(row.decision)
    },
    {
      name: "Actions",
      cell: (row) =>
        row.decision === "Hold" ? (
          <>
            <button className="btn btn-success btn-sm me-2" onClick={() => handleAcceptClick(row.id)} style={{ whiteSpace: "nowrap" }}>Accept</button>
            {/* <button className="btn btn-danger btn-sm" onClick={() => handleRejectClick(row.id)} style={{ whiteSpace: "nowrap" }}>Reject</button> */}
            <button className="btn btn-outline-danger btn-sm" onClick={() => handleDeleteClick(row.id)} style={{ whiteSpace: "nowrap" }}>Delete</button>
          </>
        ) : (
          <><button className="btn btn-outline-secondary btn-sm" onClick={() => handleDetailsClick(row.id)} style={{ whiteSpace: "nowrap" }}>Details</button></>
        )
    }
  ];
  const AcceptedView = [
    { name: "ID", selector: (row) => row.material_master?.material_code, sortable: true },
    {
      name: "Material",
      selector: (row) => row?.material_master?.material_name,
      sortable: true,
      wrap: true,
    },
    { name: "Qty", selector: (row) => row?.expected_qty },
    { name: "Batch Id", selector: (row) => row?.batch_number },
    { name: "Supplier", selector: (row) => row?.supplier_name },
    {
      name: "Date",
      selector: (row) => row?.created_at ? formatDate(row.created_at) : "",
    },
    {
      name: "Time",
      selector: (row) => {
        if (!row.created_at) return "";
        const date = new Date(row.created_at);
        return date.toLocaleTimeString("en-IN", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      },
    },
    {
      name: "Status",
      cell: (row) => getBadges(row.decision)
    },
    {
      name: "Actions",
      cell: (row) =>
        row.decision === "Hold" ? (
          <>
            <button className="btn btn-success btn-sm me-2" onClick={() => handleAcceptClick(row.id)} style={{ whiteSpace: "nowrap" }}>Accept</button>
            {/* <button className="btn btn-danger btn-sm" onClick={() => handleRejectClick(row.id)} style={{ whiteSpace: "nowrap" }}>Reject</button> */}
          </>
        ) : (
          <button className="btn btn-outline-secondary btn-sm" onClick={() => handleDetailsClick(row.id)} style={{ whiteSpace: "nowrap" }} >Details</button>
        )
    }
  ];
  return (
    <div className='container-fluid'>
      <div className="row g-3">
        <div className="col-md-12">
          <div className="card h-100 border-0 font_family">
            <strong className="fs-3 p-3">Floor Stock Status</strong>
            {loading ? (
              <Loader />
            ) : (
              <>
                {stockStatus && stockStatus?.length > 0 ? (
                  <ul className="list-group list-group-flush">
                    {stockStatus.map((item, index) => {
                      const available = parseFloat(Number(item?.available_quantity).toFixed(2));
                      const required = parseFloat(Number(item?.required_quantity).toFixed(2));
                      const minimum = parseFloat(Number(item?.minimum_quantity).toFixed(2));
                      let status = "Good";
                      let badgeClass = "bg-success-subtle text-dark";

                      if (available < minimum) {
                        status = "Critical";
                        badgeClass = "bg-danger-subtle text-dark";
                      } else if (available < required) {
                        status = "Low";
                        badgeClass = "bg-warning-subtle text-dark";
                      }
                      return (
                        <li
                          key={index}
                          className="list-group-item d-flex justify-content-between border-0"
                        >
                          {item?.material?.material_name}
                          <span className={`badge ${badgeClass} p-2`}>
                            {status} ({available} {item?.material?.unit_of_measurement})
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <div className="p-3 text-center text-muted">
                    No data record found
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <div className='row mt-4 m-1'>
        <div className='card p-3 font_family'>
          <div className=" justify-content-between align-items-center mb-3">
            <strong className="fs-4"> <RiCheckboxMultipleLine /> Material Issue Requests</strong><br />
            <div className="d-flex gap-2 mt-2">
              <button
                className="btn btn-dark"
                onClick={() => setMaterialIssue(true)}
              >
                New Material Issue
              </button>
              <button
                className="btn btn-dark"
                onClick={() => setMaterialIssueProductWise(true)}
              >
                New Material Issue (Product wise)
              </button>
            </div>

          </div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={columns}
                customStyles={customStyles}
                data={materialList}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
        </div>
      </div>
      <div className="row mt-4 m-1">
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className="fs-4"> <RiCheckboxMultipleLine /> Incoming Material Acceptance</strong>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={Acceptedcolumns}
                data={acceptedList}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
        </div>
      </div>
      <div className="row mt-4 m-1">
        <div className="card p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <strong className="fs-4"> <RiCheckboxMultipleLine /> Incoming Material Report</strong>
          </div>
          {loading ? (
            <Loader />
          ) : (
            <>
              <DataTable
                columns={AcceptedView}
                data={acceptedmaterial}
                customStyles={customStyles}
                responsive
                striped
                highlightOnHover
                pagination
              />
            </>
          )}
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-6 mb-4">
          <div className="card p-3 h-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <strong className="fs-4">Material Wastage</strong>
              <button
                className="btn btn-dark btn-sm"
                onClick={() => setMaterialWastage(true)}
              >
                Log Manually
              </button>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="container-fluid mb-3">
                  <div className="row g-3 align-items-end">

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label className="form-label small">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label className="form-label small">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                      <button
                        className="btn btn-primary w-100"
                        onClick={fetchWastageList}
                      >
                        Filter
                      </button>
                    </div>

                  </div>
                </div>
                <div className="container-fluid">
                  <div className="table-responsive">
                    <table className="table table-borderless align-middle">
                      <thead className="border-bottom">
                        <tr>
                          <th>Material</th>
                          <th>Quantity</th>
                          <th>Reason</th>
                        </tr>
                      </thead>

                      <tbody>
                        {wastageList?.material_wastes?.length > 0 ? (
                          wastageList.material_wastes.map((wastes, idx) => (
                            <tr
                              key={wastes.id}
                              className={idx % 2 !== 0 ? "table-light" : ""}
                            >
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setSuperMaterialWastageReport(true);
                                  setWastageReportId(wastes.id);
                                }}
                              >
                                {wastes?.material_master?.material_name || "NA"}
                              </td>

                              <td>
                                {wastes?.quantity} {wastes?.unit}
                              </td>

                              <td>
                                {wastes?.notes ? (
                                  <span className="small fw-semibold">
                                    {wastes.notes}
                                  </span>
                                ) : (
                                  <span className="text-muted small">—</span>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              {loading ? "Loading..." : "No wastage records found"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="col-md-6 mb-4">
          <div className="card p-3 h-100">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <strong className="fs-4 ">Material Rejection</strong>
              <button className="btn btn-dark btn-sm" onClick={() => setNewMaterial(true)}>Log New</button>
            </div>
            {loading ? (
              <Loader />
            ) : (
              <>
                <div className="container-fluid mb-3">
                  <div className="row g-3 align-items-end">

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label className="form-label small">Start Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={rejectionStartDate}
                        onChange={(e) => setRejectionStartDate(e.target.value)}
                      />
                    </div>

                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label className="form-label small">End Date</label>
                      <input
                        type="date"
                        className="form-control"
                        value={rejectionEndDate}
                        onChange={(e) => setRejectionEndDate(e.target.value)}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                      <button className="btn btn-primary w-100" onClick={fetchNewList}>
                        Filter
                      </button>
                    </div>
                  </div>
                </div>
                <div className="container-fluid">
                  <div className="table-responsive">
                    <table className="table table-borderless align-middle">
                      <thead className="border-bottom">
                        <tr>
                          <th>Material</th>
                          <th>Quantity</th>
                          <th>Reason</th>
                        </tr>
                      </thead>
                      <tbody>
                        {newLogList?.material_rejections?.length > 0 ? (
                          newLogList.material_rejections.map((rejection, idx) => (
                            <tr
                              key={rejection?.id}
                              className={idx % 2 !== 0 ? "table-light" : ""}
                            >
                              <td
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setMaterialRejectionReport(true);
                                  setRejectionReportId(rejection?.id);
                                }}
                              >
                                {rejection?.material_master?.material_name || "NA"}
                              </td>

                              <td>
                                {rejection?.quantity}{" "}
                                {rejection?.material_master?.unit_of_measurement}
                              </td>

                              <td>
                                {rejection?.reason ? (
                                  <span className="small fw-semibold">
                                    {rejection.reason}
                                  </span>
                                ) : (
                                  <span className="text-muted small">—</span>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="3" className="text-center text-muted py-4">
                              {loading ? "Loading..." : "No rejection records found"}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-12 col-md-12 d-flex">
          <div className="p-3 border rounded bg-light w-100 h-100">
            <strong className="fs-4 ">MTD Material Consumption</strong>
            <div className="p-4">
              {loading ? (
                <Loader />
              ) : (
                <>
                  <BarChart chartData={BarChartData} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* MaterialIssueRequstModal */}
      <MaterialIssueRequstModal
        show={materialIssue}
        onMaterialAdded={fetchMaterialList}
        handleClose={() => setMaterialIssue(false)}
        onAccept={() => {
          alert("Accepted");
          fetchAcceptedList();
          fetchAcceptedmaterial();
        }}
      />
      {/* MaterialIssueProductWise */}
      <MaterialIssueProductWise
        show={materialIssueProductWise}
        onMaterialAdded={fetchMaterialList}
        handleClose={() => setMaterialIssueProductWise(false)}
      />
      {/* MaterialInspectionReportModal */}
      <MaterialInspectionReportModal
        show={materialInspection}
        onAccept={() => {
          fetchAcceptedList();
          fetchAcceptedmaterial();
        }}
        materialId={selectedMaterialId}
        handleClose={() => setMaterialInspection(false)}
      />
      {/* MaterialRejectDetailsModal */}
      <MaterialRejectDetailsModal
        show={materialReject}
        materialId={selectedMaterialId}
        handleClose={() => setMaterialReject(false)}
      />
      {/* MaterialWastageLogModal */}
      <MaterialWastageLogModal
        show={materialWastage}
        onWastageLog={fetchWastageList}
        handleClose={() => setMaterialWastage(false)}
      />
      <MaterialRejectionNewLogModal
        show={newMaterial}
        onNewLog={fetchNewList}
        handleClose={() => setNewMaterial(false)}
      />
      {/* MaterialRequestModal */}
      <MaterialRequestModal
        show={materialRequest}
        selectedId={selectedId}
        handleClose={() => setMaterialRequest(false)}
      />
      {/* MaterialAcceptanceDetailsModal */}
      <MaterialAcceptanceDetailsModal
        show={materialAcceptanceDetails}
        materialId={selectedMaterialId}
        handleClose={() => setMaterialAcceptanceDetails(false)}
      />
      {/* SuperMaterialWastageReporModal */}
      <SuperMaterialWastageReporModal
        wastageReportId={wastageReportId}
        show={superMaterialWastageReport}
        handleClose={() => setSuperMaterialWastageReport(false)}
      />
      {/* MaterialRejectionReportModal */}
      <MaterialRejectionReportModal
        rejectionReportId={rejectionReportId}
        show={materialRejectionReport}
        handleClose={() => setMaterialRejectionReport(false)}
      />
      {/* SupplierModal */}
      <SupplierModal
        show={supplierModal}
        selectedId={selectedId}
        onMaterial={fetchMaterialList}
        fetchAcceptedList={fetchAcceptedList}
        handleClose={() => setSupplierModal(false)}
      />
    </div>
  )
}


